<template>
  <div class="flex h-full w-full flex-col overflow-y-auto p-6">
    <div class="mb-4">
      <lf-dropdown
        name="metadata-key-selector"
        :options="dropdownOptions"
        :value="selectedId"
        :placeholder="$t('COMMON.METADATA')"
        data-cy="metadata-key-dropdown"
        @change="$emit('select', $event?.toString() ?? '')"
      />
    </div>

    <div
      v-if="selectedValue"
      class="flex flex-1 rounded-md border border-gray-200 p-4"
      data-cy="metadata-preview"
    >
      <p
        class="whitespace-pre-wrap text-sm text-gray-600"
        data-cy="metadata-value-display"
      >
        {{ selectedValue }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import LfDropdown from "@/components/ui/inputs/LfDropdown.vue";

import type { Metadata } from "@/schemas/metadata";

const { entries, selectedId } = defineProps<{
  entries: Metadata[];
  selectedId: string;
}>();

defineEmits<{
  select: [id: string];
}>();

const dropdownOptions = computed(() => {
  const options: Record<string, string> = {};
  for (const entry of entries) {
    options[entry.id?.toString() ?? ""] = entry.key;
  }
  return options;
});

const selectedValue = computed(
  () => entries.find((e) => e.id?.toString() === selectedId)?.value
);
</script>
